import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Close as CloseIcon } from '@vicons/ionicons5';
import { ref, onBeforeMount, computed } from 'vue';
import { FormInst, NButton, NCard, NInput, NForm, NFormItemGi, NIcon, NGrid, NSpace } from 'naive-ui';
import $msg from '@/utils/message';
import getBase from '@/utils/base';
import { Password } from '@vicons/carbon';

export default /*#__PURE__*/_defineComponent({
  __name: 'EditPasswordModal',
  props: ['submitId', 'disabled'],
  emits: ['close', 'submit'],
  setup(__props, { expose, emit: emits }) {

const props = __props;

const { $store, t, changeParam } = getBase();
const user = computed(() => $store.state.auth.user);


let param = ref<any>({
	id: null,
	name: null,
	account: null,
	email: null,
});

let submitId = ref(props.submitId);
let disabled = ref(props.disabled);
onBeforeMount(() => {
	changeParam(param.value, user.value);
})
const form = ref<FormInst | null>(null);
const rules = <any>{
	rule: {
		required: true,
		message: t("validate.not_empty"),
		trigger: ['input', 'blur']
	},
	password: {
		required: true,
		trigger: ['input', 'blur'],
		validator: (rule: any, value: string) => {
			if (!value) {
				return new Error(t("validate.not_empty"));
			} else if (param.value.newPassword != param.value.rePassword) {
				return new Error(t("validate.re_password"));
			}
			return true;
		}
	},
	ruleNumber: {
		type: "number",
		required: true,
		message: t("validate.not_empty"),
		trigger: ['input', 'blur']
	},
	ruleSelect: {
		type: "number",
		required: true,
		message: t("validate.not_empty"),
		trigger: ['blur', 'change']
	},
	ruleEnumSelect: {
		required: true,
		message: t("validate.not_empty"),
		trigger: ['blur', 'change']
	}
};

function cancel() {
	emits('close');
}
function submit(e: MouseEvent) {
	e.preventDefault();
	form.value?.validate((errors) => {
		if (!errors) {
			emits('submit', param.value);
		} else {
			$msg.error(t("validate.invalid"));
		}
	})
}

expose({
	submitId,
	param
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NCard), {
    style: {"width":"500px"},
    bordered: false,
    size: "huge",
    role: "dialog",
    "aria-modal": "true"
  }, {
    "header-extra": _withCtx(() => [
      _createVNode(_unref(NButton), {
        size: "tiny",
        secondary: "",
        onClick: cancel
      }, {
        icon: _withCtx(() => [
          _createVNode(_unref(NIcon), null, {
            default: _withCtx(() => [
              _createVNode(_unref(CloseIcon))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(NSpace), { justify: "end" }, {
        default: _withCtx(() => [
          (_unref(disabled))
            ? (_openBlock(), _createBlock(_unref(NButton), {
                key: 0,
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('close')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_unref(disabled))
            ? (_openBlock(), _createBlock(_unref(NButton), {
                key: 1,
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('cancel')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_unref(disabled))
            ? (_openBlock(), _createBlock(_unref(NButton), {
                key: 2,
                type: "success",
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('submit')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(NForm), {
        ref_key: "form",
        ref: form,
        model: _unref(param),
        rules: _unref(rules),
        disabled: _unref(disabled)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NGrid), { cols: 24 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NFormItemGi), {
                "rule-path": "rule",
                path: "password",
                span: 24,
                label: _unref(t)('system.user.old_password')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    type: "password",
                    "show-password-on": "mousedown",
                    placeholder: _unref(t)('system.user.old_password'),
                    maxlength: 8,
                    size: "large",
                    value: _unref(param).password,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(param).password) = $event))
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(NIcon), { component: _unref(Password) }, null, 8, ["component"])
                    ]),
                    _: 1
                  }, 8, ["placeholder", "value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NFormItemGi), {
                "rule-path": "rule",
                path: "newPassword",
                span: 24,
                label: _unref(t)('system.user.new_password')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    type: "password",
                    "show-password-on": "mousedown",
                    placeholder: _unref(t)('system.user.new_password'),
                    maxlength: 8,
                    size: "large",
                    value: _unref(param).newPassword,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(param).newPassword) = $event))
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(NIcon), { component: _unref(Password) }, null, 8, ["component"])
                    ]),
                    _: 1
                  }, 8, ["placeholder", "value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NFormItemGi), {
                "rule-path": "password",
                path: "rePassword",
                span: 24,
                label: _unref(t)('system.user.re_password')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    type: "password",
                    "show-password-on": "mousedown",
                    placeholder: _unref(t)('system.user.re_password'),
                    maxlength: 8,
                    size: "large",
                    value: _unref(param).rePassword,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(param).rePassword) = $event))
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(NIcon), { component: _unref(Password) }, null, 8, ["component"])
                    ]),
                    _: 1
                  }, 8, ["placeholder", "value"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "disabled"])
    ]),
    _: 1
  }))
}
}

})